<template>
  <div class="profile" v-if="user.id">
    <div class="row pr-3">
      <div class="col-lg-8">
        <!-- <label v-if="user.employer_name">Organization Name</label>
        <p>{{ user.employer_name }}</p> -->
        <div class="row">
          <div class="col-lg-4" style="max-width: 175px;">

            <div v-if="user.profile_pic != 'https://enginehireio-static-and-media.s3.amazonaws.com/media/img/default_avatar.jpg'">
              <!-- {{ user.profile_pic }} -->
              <!-- https://stackoverflow.com/questions/37645243/static-image-src-in-vue-js-template -->
              <img :src="user.profile_pic" style="max-height: 150px; max-width: 150px;">
            </div>
          </div>
          <div class="col-lg-8 my-auto">
            <h2 class="mt-2" v-if="user.employer_name">{{ user.employer_name }}</h2>
            <div class="mt-3">
              <a v-if="user.website" :href="user.website" target="_blank">
                <img src="../../../assets/img/social/website_squircle_charcoal.svg" alt="youtube" class='social-icon'>
              </a>
              <a v-if="user.youtube" :href="user.youtube" target="_blank">
                <img src="../../../assets/img/social/youtube_squircle_charcoal.svg" alt="youtube" class='social-icon'>
              </a>
              <a v-if="user.facebook" :href="user.facebook" target="_blank">
                <img src="../../../assets/img/social/facebook_squircle_charcoal.svg" alt="facebook" class='social-icon'>
              </a>
              <a v-if="user.instagram" :href="user.instagram" target="_blank">
                <img src="../../../assets/img/social/instagram_squircle_charcoal.svg" alt="instagram" class='social-icon'>
              </a>
              <a v-if="user.twitter" :href="user.twitter" target="_blank">
                <img src="../../../assets/img/social/twitter_squircle_charcoal.svg" alt="twitter" class='social-icon'>
              </a>
              <a v-if="user.linkedin" :href="user.linkedin" target="_blank">
                <img src="../../../assets/img/social/linkedin_squircle_charcoal.svg" alt="linkedin" class='social-icon'>
              </a>
            </div>
          </div>
        </div>


        <label v-if="user.about_us" class="shaded-label">About Us</label>
        <div class="profile-section">
          <!-- <pre>{{ user.about_us }}</pre> -->
          <pre class="" v-html="user.about_us"></pre>
          <!-- {{ user.video }} -->
          <!-- <youtube :video-id="getIdFromURL('https://www.youtube.com/watch?v=K8KAbu45-kE')"></youtube> -->
          <youtube v-if="user.video" :video-id="videoId" width='100vw'></youtube>
        </div>

      </div>
      <div class="col-lg-4 p-4" style="background-color: var(--bootstrapgrey)">

        <p v-if="user.city">{{ user.city }}</p>
        <h4 v-if="user.country">{{ user.country }}</h4>
        <div>
          <small v-if="user.address1" style="display: block;">{{ user.address1 }}</small>
          <small v-if="user.address2" style="display: block;">{{ user.address2 }}</small>
          <small v-if="user.postal_code" style="display: block;">{{ user.postal_code }}</small>
        </div>

        <div v-if="user.city" id='map' class="mt-2" style="height: 250px; width: 100%;"></div>

        <hr v-if="user.city">

        <label v-if="user.organization_type" style="margin-top: 0;">Organization Type</label>
        <p>{{ user.organization_type }}</p>
        <label v-if="user.size">Organization Size</label>
        <p>{{ user.size }}</p>
        <span v-if="user.id"><label v-if="user.sectors[0]">Organization Sectors</label></span>
        <ul>
          <li v-for="(sector, index) in user.sectors" :key="'Sectors'+index">{{ sector }}</li>
        </ul>
        <!-- <span v-if="user.id"><label v-if="user.skills[0]">Topic Areas</label></span> -->
        <!-- <ul>
          <li v-for="(skill, index) in user.skills" :key="'Skill'+index">{{ skill }}</li>
        </ul> -->
        <span v-if="user.id"><label v-if="user.features[0]">Organization Values</label></span>
        <ul>
          <li v-for="(value, index) in user.features" :key="'Value'+index">{{ value }}</li>
        </ul>
        <span v-if="user.id"><label v-if="user.skills2[0]">Top Things Looked for in Candidates</label></span>
        <ul>
          <li v-for="(quality, index) in user.skills2" :key="'Quality'+index">{{ quality }}</li>
        </ul>
        <span v-if="user.id"><label v-if="user.features2[0]">Work Perks</label></span>
        <ul>
          <li v-for="(perk, index) in user.features2" :key="'Value'+index">{{ perk }}</li>
        </ul>
      </div>
    </div>

    <!-- <hr> -->
    <!-- <pre>{{ user.team_members }}</pre> -->
    <label v-if="user.projects" class="shaded-label">Current/Recent Projects</label>
    <pre v-if="user.projects" class="profile-section" v-html="user.projects"></pre>
    <label v-if="user.text_field1" class="shaded-label">Meet Some Team Members</label>
    <pre v-if="user.text_field1" class="profile-section" v-html="user.text_field1"></pre>
    <label v-if="user.hiring_practices" class="shaded-label">How to Get Involved</label>
    <!-- <pre class="profile-section">{{ user.hiring_practices }}</pre> -->
    <pre v-if="user.hiring_practices" class="profile-section" v-html="user.hiring_practices"></pre>
    <label v-if="user.hiring_restrictions" class="shaded-label">Hiring Restrictions</label>
    <!-- <pre class="profile-section">{{ user.hiring_restrictions }}</pre> -->
    <pre v-if="user.hiring_restrictions" class="profile-section" v-html="user.hiring_restrictions"></pre>
    <label v-if="user.hiring_advice" class="shaded-label">Advice for Candidates</label>
    <!-- <pre class="profile-section">{{ user.hiring_advice }}</pre> -->
    <pre v-if="user.hiring_advice" class="profile-section" v-html="user.hiring_advice"></pre>

  </div>
</template>

<script>
  import { getIdFromURL, getTimeFromURL } from 'vue-youtube-embed'

  import gmapsInit from '../../../utils/gmaps';

  export default {
    props: ['user', 'city'],
    data() {
      return {
        // google: null,
      }
    },
    computed: {
      videoId() {
      //   try {
      //     return getIdFromURL(this.user.video) // https://www.npmjs.com/package/vue-youtube-embed
      //   } catch (error) {
      //     console.log('Error with video id')
      //     console.error(error);
      //     return null
      //   }
        return getIdFromURL(this.user.video) // https://www.npmjs.com/package/vue-youtube-embed
      }
    },
    // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
    async mounted() {
      console.log('ran')
      // console.log(this.user)
      // var mapExists = document.getElementById("map");
      // if (mapExists) {
      if (this.user.city) {
        console.log(this.user.city)
        try { // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
          const google = await gmapsInit();
          const geocoder = new google.maps.Geocoder();
          // const map = new google.maps.Map(document.getElementById('map'), {
          //   // zoom: 12,
          //   zoom: 3,
          //   // center: {lat: 52.520, lng: 13.410}
          //   center: {lat: 15.0, lng: 0.0}
          // });
          const map = new google.maps.Map(document.getElementById('map'),
            {
              zoom: 13,
            }
          );

          // geocoder.geocode({ address: 'Austria' }, (results, status) => {

          geocoder.geocode({ address: this.user.address1 + ', ' + this.user.city + ', ' + this.user.country }, (results, status) => {
            if (status !== 'OK' || !results[0]) {
              console.log('Error with geoencoder')
              throw new Error(status);
            }

            map.setCenter(results[0].geometry.location);
            // map.fitBounds(results[0].geometry.viewport);
          });

          // var marker = new google.maps.Marker({
          //       // position: results[0].geometry.location,
          //       position: new google.maps.LatLng(49.884017, -97.168579),
          //       // label: labels[i % labels.length]
          //       // icon: jobListing.icon,
          //       // title: 'test'
          //       map: map
          //     });

          // https://developers.google.com/maps/documentation/geocoding/intro
          // https://developers.google.com/maps/faq#geocoder_queryformat
          if (this.user.address1 && this.user.city && this.user.country) {
            console.log('Trying marker')
            geocoder.geocode({ address: this.user.address1 + ', ' + this.user.city + ', ' + this.user.country }, (results, status) => {
              if (status !== 'OK' || !results[0]) {
                console.log('Error with address geoencoder')
                throw new Error(status);
              }
              else {
                console.log('Got marker')
                console.log(results[0].geometry.location)
              }

              var marker = new google.maps.Marker({
                position: results[0].geometry.location,
                // position: new google.maps.LatLng(49.884017, -97.168579),
                // label: labels[i % labels.length]
                // icon: jobListing.icon,
                // title: 'test'
                map: map
              });
            });
          }

        } catch (error) {
          console.log('Error with map')
          console.error(error);
        }
      }
      // }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/employers/profile/ProfileView.vue